<app-application-index *ngIf="app !== undefined" [app]="app"></app-application-index>
